import { JobVehicleRentClass, JobVehicleRentCurrency } from '~/shared';
import { createSlice } from '../wrappers';

export type JobOwnedVehicleItem = {
	id: string;
	model: string;
	name: string;
	owned: true;
	enabled: boolean;
};

export type JobRentVehicleItem = {
	model: string;
	name: string;
	owned: false;
	enabled: boolean;
	level: number;
	price: number;
	priceCurrency: JobVehicleRentCurrency;
	class: JobVehicleRentClass;
};

const initialState = {
	showModal: false,
	modalType: 'about',
	aboutTabIndex: 0,
	aboutTabMaxIndex: 0,
	vehicleTabIndex: 0,
	vehicleTabMaxIndex: 0,
	vehicleTabClass: null as JobVehicleRentClass | 'owned' | null,
	vehicleList: [] as (JobOwnedVehicleItem | JobRentVehicleItem)[],
	selectedVehicle: null as JobOwnedVehicleItem | JobRentVehicleItem | null,
};

const modalSlice = createSlice({
	name: 'modal',
	initialState,
	reducers: {
		showModal: (state) => {
			state.showModal = true;
		},
		hideModal: (state) => {
			state.showModal = false;
		},
		showAboutModal: (state) => {
			state.showModal = true;
			state.modalType = 'about';
			state.aboutTabIndex = 0;
		},
		showVehsModal: (state) => {
			state.showModal = true;
			state.modalType = 'vehs';
			state.vehicleTabIndex = 0;
		},
		setModalType: (state, action) => {
			state.modalType = action.payload;
		},
		setAboutTabIndexPrev: (state) => {
			const index = state.aboutTabIndex;
			state.aboutTabIndex = index > 0 ? index - 1 : index;
		},
		setAboutTabIndexNext: (state) => {
			const index = state.aboutTabIndex;
			const maxIndex = state.aboutTabMaxIndex;
			state.aboutTabIndex = index < maxIndex ? index + 1 : index;
		},
		setAboutTabMaxIndex: (state, action) => {
			state.aboutTabMaxIndex = action.payload;
		},
		setVehicleTabIndexPrev: (state) => {
			const index = state.vehicleTabIndex;
			state.vehicleTabIndex = index > 0 ? index - 1 : index;
		},
		setVehicleTabIndexNext: (state) => {
			const index = state.vehicleTabIndex;
			const maxIndex = state.vehicleTabMaxIndex;
			state.vehicleTabIndex = index < maxIndex ? index + 1 : index;
		},
		setVehicleTabIndex: (state, action) => {
			state.vehicleTabIndex = action.payload;
		},
		setVehicleTabMaxIndex: (state, action) => {
			state.vehicleTabMaxIndex = Math.max(action.payload, 0);
		},
		setVehicleTabClass: (state, action) => {
			state.vehicleTabClass = action.payload;
		},
		setVehicleList: (state, action) => {
			state.vehicleList = action.payload;
		},
		setSelectedVehicle: (state, action) => {
			state.selectedVehicle = action.payload;
		},
	},
});

export const {
	showModal,
	hideModal,
	showAboutModal,
	showVehsModal,
	setModalType,
	setAboutTabIndexPrev,
	setAboutTabIndexNext,
	setAboutTabMaxIndex,
	setVehicleTabIndexPrev,
	setVehicleTabIndexNext,
	setVehicleTabIndex,
	setVehicleTabMaxIndex,
	setVehicleTabClass,
	setVehicleList,
	setSelectedVehicle,
} = modalSlice.actions;

export default modalSlice.reducer;
